import React from "react";
import { CONTAINER } from "../ui";
import { STAGES } from "../content";

// Reads the landing page's own stage list so the two pages cannot describe the journey
// differently; only the one-word label and the number are shown here.
export default function JourneyStrip() {
  return (
    <div className="tw-border-y tw-border-[#dbe8f2] tw-bg-white tw-py-10">
      <ol
        aria-label="The four stages of running a mentoring programme"
        className={`${CONTAINER} tw-m-0 tw-grid tw-list-none tw-grid-cols-4 tw-gap-8 tw-p-0 sm:tw-grid-cols-2 sm:tw-gap-6 xs:tw-grid-cols-1`}
      >
        {STAGES.map((stage) => (
          <li key={stage.number} className="tw-min-w-0">
            <p className="tw-m-0 tw-text-xs tw-font-black tw-tracking-[.14em] tw-text-[#0068b8]">
              {stage.number} / {stage.label.toUpperCase()}
            </p>
            <p className="tw-mt-2.5 tw-mb-0 tw-text-sm tw-font-bold tw-leading-6 tw-text-[#314b64]">
              {stage.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
}
